import { createSlice } from '@reduxjs/toolkit';
import { IState } from 'shared/interfaces/state.interface';
import { initialStore } from '../initial-store';

// Slice
const labsSlice = createSlice({
  name: 'labs',
  initialState: initialStore.labs,
  reducers: {
    getLabs: (state) => {
      if (!state.isLoading) {
        state.isLoading = true;
      }
    },
    setLabs: (state, { payload }) => {
      state.isLoading = false;
      state.labs = payload;
    },
    failAction: (state) => {
      state.isLoading = false;
    }
  }
});

export const { getLabs, setLabs, failAction } = labsSlice.actions;

export const { reducer } = labsSlice;

// Selectors
export const getLabsSelector = (state: IState) => state && state.labs.labs;
